import logoSenai from "../../images/certificates/logoSenai.jpg";
import logoAlura from "../../images/certificates/logoAlura.png";
import logoDevclub from "../../images/certificates/logoDevclub.png";
import logoFaesa from "../../images/certificates/logoFaesa.jpg";
import logoFullStackClub from "../../images/certificates/logoFullStackClub.png";
import logoHashtag from "../../images/certificates/logoHashtag.webp";
import logoIfes from "../../images/certificates/logoIfes.png";
import logoRocketseat from "../../images/certificates/logoRocketseat.png";
import logoUdemy from "../../images/certificates/logoUdemy.png";
import senai1 from "../../images/certificates/certificates/Senai/senai1.pdf";
import senai2 from "../../images/certificates/certificates/Senai/senai2.pdf";
import alura1 from "../../images/certificates/certificates/Alura/alura1.pdf";
import alura2 from "../../images/certificates/certificates/Alura/alura2.pdf";
import alura3 from "../../images/certificates/certificates/Alura/alura3.pdf";
import devclub1 from "../../images/certificates/certificates/DevClub/devclub1.pdf";
import devclub2 from "../../images/certificates/certificates/DevClub/devclub1.pdf";
import devclub3 from "../../images/certificates/certificates/DevClub/devclub1.pdf";
import devclub4 from "../../images/certificates/certificates/DevClub/devclub1.pdf";
import devclub5 from "../../images/certificates/certificates/DevClub/devclub1.pdf";
import devclub6 from "../../images/certificates/certificates/DevClub/devclub1.pdf";
import devclub7 from "../../images/certificates/certificates/DevClub/devclub1.pdf";
import devclub8 from "../../images/certificates/certificates/DevClub/devclub1.pdf";
import fullstack1 from "../../images/certificates/certificates/FullStackClub/fullstack1.pdf";
import hashtag1 from "../../images/certificates/certificates/Hashtag/hashtag1.pdf";
import hashtag2 from "../../images/certificates/certificates/Hashtag/hashtag2.pdf";
import ifes1 from "../../images/certificates/certificates/Ifes/ifes1.pdf";
import ifes2 from "../../images/certificates/certificates/Ifes/ifes2.pdf";
import rocket1 from "../../images/certificates/certificates/Rocketseat/rocket1.pdf";
import rocket2 from "../../images/certificates/certificates/Rocketseat/rocket2.pdf";
import rocket3 from "../../images/certificates/certificates/Rocketseat/rocket3.pdf";
import rocket4 from "../../images/certificates/certificates/Rocketseat/rocket4.pdf";
import rocket5 from "../../images/certificates/certificates/Rocketseat/rocket5.pdf";
import udemy1 from "../../images/certificates/certificates/Udemy/udemy1.pdf";
import faesa1 from "../../images/certificates/certificates/Faesa/faesa1.pdf";
import faesa2 from "../../images/certificates/certificates/Faesa/faesa2.pdf";
import faesa3 from "../../images/certificates/certificates/Faesa/faesa3.pdf";
import faesa4 from "../../images/certificates/certificates/Faesa/faesa4.pdf";
import faesa5 from "../../images/certificates/certificates/Faesa/faesa5.pdf";
import faesa6 from "../../images/certificates/certificates/Faesa/faesa6.pdf";
import faesa7 from "../../images/certificates/certificates/Faesa/faesa7.pdf";
import faesa8 from "../../images/certificates/certificates/Faesa/faesa8.pdf";
import faesa9 from "../../images/certificates/certificates/Faesa/faesa9.pdf";
import faesa10 from "../../images/certificates/certificates/Faesa/faesa10.pdf";

export const certificates = [
  {
    id: 1,
    title: "Programador Web",
    org: "Senai",
    img: logoSenai,
    category: "Senai",
    link: senai1,
  },
  {
    id: 2,
    title: "Lógica de Programação em JavaScript",
    org: "Alura",
    img: logoAlura,
    category: "Alura",
    link: alura1,
  },
  {
    id: 3,
    title: "Imerção Inteligencia Artificial",
    org: "Alura",
    img: logoAlura,
    category: "Alura",
    link: alura2,
  },
  {
    id: 4,
    title: "Imersão dev Back-end ",
    org: "Alura",
    img: logoAlura,
    category: "Alura",
    link: alura3,
  },
  {
    id: 5,
    title: "Certificado MEC - Full Stack",
    org: "DevClub",
    img: logoDevclub,
    category: "DevClub",
    link: devclub1,
  },
  {
    id: 6,
    title: "Javascript Intermediário",
    org: "DevClub",
    img: logoDevclub,
    category: "DevClub",
    link: devclub2,
  },
  {
    id: 7,
    title: "HTML, CSS, Git e GitHub",
    org: "DevClub",
    img: logoDevclub,
    category: "DevClub",
    link: devclub3,
  },
  {
    id: 8,
    title: "Node e Javascript Avançado",
    org: "DevClub",
    img: logoDevclub,
    category: "DevClub",
    link: devclub4,
  },
  {
    id: 9,
    title: "React e CSS Avançado",
    org: "DevClub",
    img: logoDevclub,
    category: "DevClub",
    link: devclub5,
  },
  {
    id: 10,
    title: "TypeScript - Frontend - DevBills",
    org: "DevClub",
    img: logoDevclub,
    category: "DevClub",
    link: devclub6,
  },
  {
    id: 11,
    title: "TypeScript - Frontend pt.2 - DevBills",
    org: "DevClub",
    img: logoDevclub,
    category: "DevClub",
    link: devclub7,
  },
  {
    id: 12,
    title: "Programador em 72h",
    org: "DevClub",
    img: logoDevclub,
    category: "DevClub",
    link: devclub8,
  },
  {
    id: 13,
    title: "Certificado FullStack Week",
    org: "Full Stack Club",
    img: logoFullStackClub,
    category: "Full Stack Club",
    link: fullstack1,
  },
  {
    id: 14,
    title: "Intensivão de JavaScript",
    org: "Hashtag Treinamentos",
    img: logoHashtag,
    category: "Hashtag Treinamentos",
    link: hashtag1,
  },
  {
    id: 15,
    title: "Jornada FullStack",
    org: "Hashtag Treinamentos",
    img: logoHashtag,
    category: "Hashtag Treinamentos",
    link: hashtag2,
  },
  {
    id: 16,
    title: "Programação de Aplicativos Web - Front-End",
    org: "Ifes",
    img: logoIfes,
    category: "Ifes",
    link: ifes1,
  },
  {
    id: 17,
    title: "Programação com JavaScript e Node.js - Back-End",
    org: "Ifes",
    img: logoIfes,
    category: "Ifes",
    link: ifes2,
  },
  {
    id: 18,
    title: "NLW Pocket: Mobile - React Native",
    org: "Rocketseat",
    img: logoRocketseat,
    category: "Rocketseat",
    link: rocket1,
  },
  {
    id: 19,
    title: "NLW Agents - Avançado em ReactJS",
    org: "Rocketseat",
    img: logoRocketseat,
    category: "Rocketseat",
    link: rocket2,
  },
  {
    id: 20,
    title: "NLW Connect - Fullstack",
    org: "Rocketseat",
    img: logoRocketseat,
    category: "Rocketseat",
    link: rocket3,
  },
  {
    id: 21,
    title: "Curso Online de PHP",
    org: "Rocketseat",
    img: logoRocketseat,
    category: "Rocketseat",
    link: rocket4,
  },
  {
    id: 22,
    title: "Inspetor de Qualidade",
    org: "Senai",
    img: logoSenai,
    category: "Senai",
    link: senai2,
  },
  {
    id: 23,
    title: "SQL para Análise de Dados",
    org: "Udemy",
    img: logoUdemy,
    category: "Udemy",
    link: udemy1,
  },
  {
    id: 24,
    title: "Fundamentos do Inglês",
    org: "Faesa",
    img: logoFaesa,
    category: "Faesa",
    link: faesa1,
  },
  {
    id: 25,
    title: "Gerenciamento de Projetos de Software",
    org: "Faesa",
    img: logoFaesa,
    category: "Faesa",
    link: faesa2,
  },
  {
    id: 26,
    title: "Comunicação e Escrita",
    org: "Faesa",
    img: logoFaesa,
    category: "Faesa",
    link: faesa3,
  },
  {
    id: 27,
    title: "Coaching e Carreira",
    org: "Faesa",
    img: logoFaesa,
    category: "Faesa",
    link: faesa4,
  },
  {
    id: 28,
    title: "Atitude Empreendedora",
    org: "Faesa",
    img: logoFaesa,
    category: "Faesa",
    link: faesa5,
  },
  {
    id: 29,
    title: "Fundamentos do Inglês",
    org: "Faesa",
    img: logoFaesa,
    category: "Faesa",
    link: faesa6,
  },
  {
    id: 30,
    title: "Gerenciamento de Projetos de Software",
    org: "Faesa",
    img: logoFaesa,
    category: "Faesa",
    link: faesa7,
  },
  {
    id: 31,
    title: "Comunicação e Escrita",
    org: "Faesa",
    img: logoFaesa,
    category: "Faesa",
    link: faesa8,
  },
  {
    id: 32,
    title: "Coaching e Carreira",
    org: "Faesa",
    img: logoFaesa,
    category: "Faesa",
    link: faesa9,
  },
  {
    id: 33,
    title: "Atitude Empreendedora",
    org: "Faesa",
    img: logoFaesa,
    category: "Faesa",
    link: faesa10,
  },
  {
    id: 34,
    title: "Imersão Desenvolvimento e Automação com IA - Build & Automate",
    org: "Rocketseat",
    img: logoRocketseat,
    category: "Rocketseat",
    link: rocket5,
  },
];
